/**
 * Expense category colour helpers.
 *
 * Categories moved from a fixed choices field to the ExpenseCategory table, so
 * a row's `category` is now a UUID and its colour comes from the API as an
 * Ant Design palette name in `category_color`. Ant components take that name
 * directly; Recharts needs a hex value, hence the lookup below.
 */

// Ant Design preset palette, primary shade
export const ANT_COLOR_HEX = {
  magenta: '#eb2f96',
  red: '#f5222d',
  volcano: '#fa541c',
  orange: '#fa8c16',
  gold: '#faad14',
  lime: '#a0d911',
  green: '#52c41a',
  cyan: '#13c2c2',
  blue: '#1890ff',
  geekblue: '#2f54eb',
  purple: '#722ed1',
};

/** Chart fill for a category row, falling back to the report palette. */
export const categoryFill = (item, index, palette) =>
  ANT_COLOR_HEX[item?.category_color] || palette[index % palette.length];

/** Display label for a category row; never render the raw UUID. */
export const categoryLabel = (item) => item?.category_name || 'Uncategorized';
